"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.decodeCookie = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var setCookie = function setCookie(name, options) {
  var _ref = options || {},
    _ref$days = _ref.days,
    days = _ref$days === void 0 ? 1 : _ref$days,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? true : _ref$value;
  var curDate = new Date();
  _jsCookie.default.set(name, JSON.stringify(value), {
    expires: new Date(curDate.setDate(curDate.getDate() + days))
  });
};
exports.setCookie = setCookie;
var decodeCookie = function decodeCookie(cookie) {
  return cookie ? JSON.parse(decodeURIComponent(cookie)) : '';
};
exports.decodeCookie = decodeCookie;